<template>
  <div class="two1_switch">
    <!-- 综合 -->
    <div :class="{ choose_item: chooseIndex === 0 }" class="switch_item">
      <div
        :class="{ choose_font: chooseIndex === 0 }"
        class="item_title"
        @click="switchCate(0)"
      >
        <span>综合</span>
      </div>
      <div v-if="chooseIndex === 0" class="bor_line"></div>
    </div>
    <!-- 新品 -->
    <div :class="{ choose_item: chooseIndex === 1 }" class="switch_item">
      <div
        :class="{ choose_font: chooseIndex === 1 }"
        class="item_title"
        @click="switchCate(1)"
      >
        <span>新品</span>
        <div class="cate_icon" @click="slotSwitch()">
          <img :src="topNew ? top1 : top2" alt="" class="top_icon" />
          <img
            :src="bottomNew ? bottom1 : bottom2"
            alt=""
            class="bottom_icon"
          />
        </div>
      </div>
      <div v-if="chooseIndex === 1" class="bor_line"></div>
    </div>
    <!-- 价格 -->
    <div :class="{ choose_item: chooseIndex === 2 }" class="switch_item">
      <div
        :class="{ choose_font: chooseIndex === 2 }"
        class="item_title"
        @click="switchCate(2)"
      >
        <span>价格</span>
        <div class="cate_icon" @click="slotSwitch()">
          <img :src="topPrice ? top1 : top2" alt="" class="top_icon" />
          <img
            :src="bottomPrice ? bottom1 : bottom2"
            alt=""
            class="bottom_icon"
          />
        </div>
      </div>
      <div v-if="chooseIndex === 2" class="bor_line"></div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      // cateList: ["综合", "新品", "价格"],
      chooseIndex: 0,
      topNew: false,
      bottomNew: true,
      topPrice: false,
      bottomPrice: true,
      top1: require("@/assets/category/top1@2x.png"), //灰色
      top2: require("@/assets/category/top2@2x.png"), //黑色
      bottom1: require("@/assets/category/bottom1@2x.png"), //灰色
      bottom2: require("@/assets/category/bottom2@2x.png"), //黑色
      // slotArrow: [
      //   {
      //     top1: require("@/assets/category/top1@2x.png"),
      //     bottom1: require("@/assets/category/bottom1@2x.png")
      //   },
      //   {
      //     top2: require("@/assets/category/top2@2x.png"),
      //     bottom2: require("@/assets/category/bottom2@2x.png")
      //   }
      // ],
      // top: false
      newSlot: "",
      proceSlot: ""
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
    switchCate(index) {
      this.chooseIndex = index;
      if (index == 1) {
        this.topNew = !this.topNew;
        this.bottomNew = !this.bottomNew;
        this.topPrice = false;
        this.bottomPrice = true;
        this.newSlot = this.topNew ? "desc" : "asc";
      } else if (index == 2) {
        this.topNew = false;
        this.bottomNew = true;
        this.topPrice = !this.topPrice;
        this.bottomPrice = !this.bottomPrice;
        this.proceSlot = this.topPrice ? "desc" : "asc";
      } else {
        this.topPrice = false;
        this.bottomPrice = true;
        this.topNew = false;
        this.bottomNew = true;
      }
      this.$emit("switchCate", index, this.newSlot, this.proceSlot);
    },
    slotSwitch() {
      this.$emit("slotSwitch");
    }
  }
};
</script>

<style lang="less" scoped>
.two1_switch {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: just-between;
  font-size: 0;
  .switch_item {
    flex: 1;
    position: relative;
    .item_title {
      display: inline-block;
      font-size: 14px;
      font-weight: 400;
      color: #000;
      line-height: 44px;
    }
  }
  .choose_item {
    .choose_font {
      font-weight: 500 !important;
      color: #222 !important;
    }
  }
  .bor_line {
    width: 25px;
    height: 4px;
    background: #000;
    border-radius: 2px;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -13px;
  }
  .cate_icon {
    display: inline-block;
    margin-left: 5px;
    box-sizing: border-box;
    .top_icon {
      display: block;
      margin-bottom: 2px;
      width: 6px;
      margin-bottom: 2px;
    }
    .bottom_icon {
      display: block;
      width: 6px;
      margin-top: 2px;
    }
  }
}
</style>
